<button class="{{statusclass}}" (click)="onClick()" ><strong>{{title}}</strong></button>